module.exports = __webpack_public_path__ + "static/media/Circo2025_20.52b83ffc.webp";